/* eslint-disable no-console, no-unused-vars */
import './modules/globals';
import './modules/location-utils';
import './modules/modals';
import './modules/sliders';
import './modules/tabs';
import './modules/video-gallery';
import './modules/widen-image-utils';
import './modules/product-solutions-gallery';

import * as AccountInfoEdit from './modules/consumer-account/account-info-edit';
import * as AccountSidebarNav from './modules/consumer-account/account-sidebar-nav';
import * as CreateAccount from './modules/consumer-account/create-account';
import * as FormValidationUtils from './utils/form-validation-utils';
import * as Login from './modules/consumer-account/login';
import * as StorageActions from './modules/consumer-account/storage-actions';
import * as SwatchbookUtils from './modules/swatchbook-utils';

import { attachNavEvents, buildPaginationHtml, resizeSliderArrows } from './modules/color-books';
import {
  dispatchSiteEvent,
  initSiteEvents,
} from './events/site-events';
import {
  getDigitalUserId,
  getLoggedInStatus,
  getUserId,
  getEmail,
  getPhoneNumber,
} from './modules/consumer-account/authentication';
import { getValByCustomFieldName } from './utils/drip-utils';

import AsFeaturedCarousels from './modules/as-featured';
import DesktopNavMenus from './modules/desktop-nav-menus';
import FlipCards from './modules/flip-cards';
import GridSliders from './modules/grid-sliders';
import HeaderSearch from './modules/header-search';
import ImageComparisonSlider from './modules/image-comparison-slider';
import InPageNav from './modules/in-page-nav';
import LazyLoad from './modules/lazyload';
import LocalNav from './modules/local-nav';
import MiniGallery from './modules/mini-gallery';
import MinifiedHeader from './modules/minified-header';
import MobileNavNew from './modules/mobile-nav-new';
import SiteModal from './modules/site-modal';
import SwatchCartIndicator from './modules/swatch-cart-indicator';
import initAuthGatedLinks from './modules/auth-gated-links';
import initSwatchOrderTracking from './modules/klaviyo/swatch-order';
import TabRole from './modules/accessibility/tab-role';
import Tabnav from './modules/tabnav';
import WidenImageSizes from './modules/widen-image-sizes';
import { addTooltipsOnPageLoad } from './modules/tooltips';
import { announceMessage } from './modules/accessibility/status-messages';
import { bundleSelector } from './modules/new-dealer-sampling';
import { getCookie } from './modules/signup-form';
import { getParameterByName } from './utils/url-utils';
import { logout } from './modules/consumer-account/account-api';
import { initBlogFilters } from './modules/blog-filters';
import { initSwatchPage } from './modules/swatch-page';
import { initAccountSwatchDetail } from './modules/consumer-account/account-swatch-detail';
import { initScrollToTop } from './modules/scroll-to-top';
import setProgressBubbleStep from './utils/progress-bubbles';

window.SiteModal = SiteModal;
window.dispatchSiteEvent = dispatchSiteEvent;
window.setProgressBubbleStep = setProgressBubbleStep;
window.localTesting = false;
window.getDigitalUserId = getDigitalUserId;
window.isAuthenticated = getLoggedInStatus();
window.useLocalStorage = false;
window.userId = getUserId();
getEmail();
getPhoneNumber();
// window.hashedEmail = getHashedEmail();
window.micrositeName = 'graberblinds';
window.brandId = '2';
window.jsVersion = '2.1.5';

// Local Storage
window.ls.isLocalStorage = window.ls.localStorageCheck();
// Swatchbook
window.swatchbook = SwatchbookUtils;
window.swatchbook.init();
window.swatchbook.data = window.swatchbook.getSwatchbookData();
// Sliders
window.sliders.init();
// Account methods
window.Login = Login;
window.Login.init();
window.FormValidationUtils = FormValidationUtils;
window.StorageActions = StorageActions;
// Global reference for GA, accessibility utils
window.announceMessage = announceMessage;
window.getParameterByName = getParameterByName;
// Get cookie function from signup-form. used to detect isGraberDealer cookie
window.getCookie = getCookie;
// GTM legacy dependencies
window.epiHelpers = {
  getValByMailchimpField: (name) => {
    getValByCustomFieldName(document, name);
  },
};

AsFeaturedCarousels();
DesktopNavMenus();
FlipCards();
HeaderSearch();
ImageComparisonSlider.initComparisons();
initSiteEvents();
LazyLoad();
WidenImageSizes();
LocalNav();
MinifiedHeader({
  headerDiv: document.querySelector('.header'),
  minClass: 'is-fixed',
});
MobileNavNew();
addTooltipsOnPageLoad();
GridSliders();
MiniGallery();
SwatchCartIndicator();
// Does nothing off the order confirmation page. Must follow SwatchCartIndicator() so the
// header badge is listening when clearing the cart fires graber:cart-updated.
initSwatchOrderTracking();
initAuthGatedLinks([
  {
    selector: [
      '.icon-item-my-cart a.icon-nav-item',
      '.icon-item-cart a.icon-nav-item',
      '.primary-item-my-cart a',
      '.primary-item-cart a',
    ].join(', '),
    getReturnUrl: () => window.cartUrl,
  },
]);
Tabnav();
TabRole(); // Accessibility

if (document.querySelector('[data-filter-bar="blog"]')) {
  initBlogFilters();
}

if (document.getElementById('swatches-app')) {
  initSwatchPage();
}

if (document.getElementById('account-favorites-app') && document.getElementById('swatch-detail-panel')) {
  initAccountSwatchDetail();
}

initScrollToTop();

window.logoutUser = () => {
  logout({
    onSuccess: () => {
      window.swatchbook.clearAllSwatchbookData();
      window.location = window.loginUrl;
    },
  });
};

if (document.querySelector('.js-account-info') !== null) {
  AccountInfoEdit.init();
}
if (document.querySelector('.account-section-nav') !== null) {
  AccountSidebarNav.init();
}
// Create Account, Modal (the in-page create-account form is a standard MVC post
// handled server-side by CreateAccountPageController, so it needs no JS here).
if (document.querySelector('.modal-acct-create-form') !== null) {
  CreateAccount.init({
    form: document.querySelector('.modal-acct-create-form'),
    disableScroll: true,
  });
}
if (document.querySelector('.in-page-nav') !== null) {
  InPageNav();
}
// Build colorbook pagination
if (document.querySelector('.sidebar-nav') !== null) {
  buildPaginationHtml();
  attachNavEvents('.nav-section-heading');
  window.addEventListener('resize', resizeSliderArrows);
  const itemsWithCaptions = document.querySelectorAll('.image-with-caption');
  itemsWithCaptions.forEach(item => item.addEventListener('touchstart', () => item.classList.toggle('touched')));
}
/* eslint-enable no-console, no-unused-vars */

// initialize New Dealer Sampling
bundleSelector();
